import * as React from 'react';
import { Route, Switch } from 'react-router';
import { Col, Container, Row } from 'reactstrap';
import './Reports.css';
import ReportForAnonymousUser from './ReportForAnonymousUser';
import ReportForRegisteredUser from './ReportForRegisteredUser';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { push } from 'connected-react-router';
import { ApplicationState } from '../../store';

type ReportsProps = ReturnType<typeof mapDispatchToProps> & {

};

interface ReportsState {
    isLoading: boolean;
    hasError: boolean;
    embedUrl: string | null;
}

class Reports extends React.Component<ReportsProps, ReportsState> {
    constructor(props: ReportsProps) {
        super(props);
        this.state = {
            isLoading: true,
            hasError: false,
            embedUrl: null
        }
    }

    public render() {
        return (
            <>
                <Switch>
                    <Route exact path={'/console/report/anonymous-user'}>
                        <ReportForAnonymousUser />
                    </Route>
                    <Route exact path={'/console/report/registered-user'}>
                        <ReportForRegisteredUser />
                    </Route>
                    <Route>
                        <ReportForAnonymousUser />
                        {/*<Container fluid>*/}
                        {/*    <h4>Reports</h4>*/}
                        {/*    <Row>*/}
                        {/*        <Col xs={12} className="px-0 d-flex justify-content-center">*/}
                        {/*            <table className="table">*/}
                        {/*                <tbody>*/}
                        {/*                    <tr>*/}
                        {/*                        <td><button className="btn btn-primary" onClick={() => this.props.push("report/anonymous-user")}>Report for Anonymous User</button></td>*/}
                        {/*                    </tr>*/}
                        {/*                    <tr>*/}
                        {/*                        <td><button className="btn btn-primary" onClick={() => this.props.push("report/registered-user")}>Report for Registered User</button></td>*/}
                        {/*                    </tr>*/}
                        {/*                </tbody>*/}
                        {/*            </table>*/}
                        {/*        </Col>*/}
                        {/*    </Row>*/}
                        {/*</Container>*/}
                    </Route>
                </Switch>
            </>
        );
    }
}

const mapStateToProps = (state: ApplicationState) => {
    return {
        console: state.console
    }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        push: (path: string) => dispatch(push(path))
    }
}

export default connect(null, mapDispatchToProps)(Reports);
